export const WELCOME_BONUS_JUST_REGISTERED_KEY = "welcomeBonusJustRegistered";
export const AUTH_SESSION_ID_KEY = "authSessionId";
export const AUTH_SESSION_USER_ID_KEY = "authSessionUserId";
export const WELCOME_BONUS_SHOWN_SESSION_ID_KEY = "welcomeBonusShownSessionId";
export const UNLOCK_NEXT_BONUS_SHOWN_SESSION_ID_KEY = "unlockNextBonusShownSessionId";

